<template>
  <!-- 搜索结果页面---左侧菜单 -->
  <div class="searchResult_leftmenu">
    <h4>年份</h4>
    <div class="yearshow_wap" v-if="yearShow">
      <div>{{years}}</div>
      <div @click="back_">
        <img src="../../../assets/cha.png" alt />
      </div>
    </div>

    <div v-else>
      <ul
        :style="{height:needIndex?(34*leftMenuList.length-4)+'px':34*5+'px'}"
        v-show="leftMenuList[0]"
      >
        <li v-for="(item,index) in leftMenuList" :key="index" v-show="item.nums!=0" @click="listlink(index)">
          <p>{{item.year}}</p>
          <p>{{item.nums}}</p>
        </li>
      </ul>
      <div class="footerBtn" v-show="leftMenuList[0]">
        <button class="button_simple_2 buttinInput" @click="needIndex=!needIndex">
          <img
            src="@/assets/jianTou.png"
            alt
            :style="{transform:needIndex?'rotate(0deg)':'rotate(180deg)'}"
          />
        </button>
      </div>
    </div>

    <!-- 左侧菜单加载loding -->
    <div class="lodingMenu" v-show="leftMenuList[0]?false:true">
      <div>...</div>
      <p>加载中</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "searchResultComponent",
  props: {
    leftMenuList: {
      type: Array,
      default: ()=>[]
    }
  },
  data() {
    return {
      // 年份赋值
      years: "",
      // 点击年份显示隐藏
      yearShow: false,
      needIndex: false
      // menuList:[]
    };
  },
  methods: {
    //   点击列表修改样式
    listlink(index) {
      this.yearShow = true
      this.years = this.leftMenuList[index].year;
      this.needIndex=false
      this.$emit('yearSet',this.years)
      // this.ind = index
    },
    // 返回列表
    back_(){
      this.years = '',
      this.$emit('yearSet',this.years)
      this.yearShow = false
    }
  },
  mounted() {
    console.log(this.leftMenuList);
  }
};
</script>

<style scoped lang="less">
.yearshow_wap {
  width: 100%;
  background: #f9f9f9;
  border-radius: 5px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div:nth-child(1) {
    line-height: 40px;
  }
  div:nth-child(2) {
    width: 15px;
    height: 15px;
    img {
      width: 100%;
    }
  }
}
// .active{
//     background: #f7f7f7;
//     border-radius: 5px;
//     border: 1px #F9F9F9 solid;
//     padding: 0 5px;
// }
.searchResult_leftmenu {
  width: 360px;
  // height:100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
  h4 {
    height: 40px;
    font-size: 18px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    padding-bottom: 10px;
  }
  ul {
    transition: all 0.3s ease 0s;
    overflow: hidden;
    padding-bottom: 2px;
    li {
      display: flex;
      margin-bottom: 4px;
      cursor: pointer;
      justify-content: space-between;
      p {
        height: 30px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
      }
      p:first-child:hover {
        color: #1966ff;
      }
    }
    li:last-child {
      margin-bottom: 0;
    }
  }
  .footerBtn {
    padding: 20px 0;
    .buttinInput {
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.1);
      img {
        height: 12px;
        transition: 0.3s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/searchResult/searchResultComponents/leftMenu.vue